const componentState = {
    operational: 1,
    degradedPerformance: 2,
    partialOutage: 3,
    majorOutage: 4,
    underMaintenance: 5
};

export default componentState;
